/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import { Text } from '@leverege/ui-elements'

import { useSelector } from 'react-redux'

function Component( { variant } ) {
  const { globalstarSubscriptionInfo } = useSelector( state => state.ui )

  return <Text variant={variant || 'detailValue'}>{globalstarSubscriptionInfo?.anniversaryDate ? 'Valid' : '-'}</Text>
}

export default {
  objectType : 'boat',
  attrName : 'Globalstar Subscription Status',
  renderer : ( value, valueStyle, object, context, options ) => React.createElement( Component, { variant: options.valueVariant } )
} 
